
import { httpV2 } from "@/api";

/**
 * Obtém os modelos de configuração de limites de tendência de frequência.
 * É utilizado um POST ao invés do GET para não exceder o tam da URL.
 * @param {array} ids - IDs dos elementos de monitoramento.
 * @returns {promise} Promessa que resolve com os modelos de configuração de limites de tendência de frequência.
 */
const GetFrequencyTrendLimitsConfigurationModels = function(ids)
{
	return httpV2.post("/FrequencyTrendLimitConfigurations/Models", ids);
};

/**
 * Atualiza os modelos de configuração de limites de tendência de frequência.
 * @param {object} model - O modelo de configuração de limites de tendência de frequência a ser atualizado.
 * @returns {promise} Promessa que resolve com a resposta da atualização.
 */
const UpdateFrequencyTrendLimitsConfiguration = function(model)
{
	const id = model.frequencyTrendsLimitsId;
	return httpV2.put(`/FrequencyTrendLimitConfigurations/${id}`, model);
};

/**
 * Cria os modelos de configuração de limites de tendência de frequência.
 * @param {object} model - O modelo de configuração de limites de tendência de frequência a ser atualizado.
 * @returns {promise} Promessa que resolve com a resposta da atualização.
 */
const CreateFrequencyTrendLimitsConfiguration = function(model)
{
	return httpV2.post("/FrequencyTrendLimitConfigurations", model);
};

/**
 * Apaga os modelos de configuração de limites de tendência de frequência.
 * @param {object} model - O modelo de configuração de limites de tendência de frequência a ser apagado.
 * @returns {promise} Promessa que resolve com a resposta da atualização.
 */
const DeleteFrequencyTrendLimitsConfiguration = function(model)
{
	const { id, limitsDisable } = model;
	return httpV2.delete(`/FrequencyTrendLimitConfigurations/${id}?limitsDisable=${limitsDisable}`);
};

export default {
	GetFrequencyTrendLimitsConfigurationModels,
	UpdateFrequencyTrendLimitsConfiguration,
	CreateFrequencyTrendLimitsConfiguration,
	DeleteFrequencyTrendLimitsConfiguration,
};